import { io } from "socket.io-client";

// Résolution de l'URL socket:
// - Si VITE_SERVER_HOST est défini (utile en LAN), on l'utilise.
// - Sinon undefined => io() utilisera la même origine (permet au proxy Vite de router /socket.io).
const serverHost = import.meta.env.VITE_SERVER_HOST || "";
const socketUrl = serverHost || undefined;

/*
  Options importantes:
  - autoConnect: false => on attache d'abord les handlers, puis on appelle socket.connect()
    (évite d'émettre des événements avant que les handlers soient prêts).
  - path: '/socket.io' explicite l'endpoint utilisé (utile derrière des proxies).
  - reconnection* : paramètres défensifs pour limiter les tentatives infinies.
*/
export const socket = io(socketUrl, {
  path: "/socket.io",
  // polling d'abord = connexion immédiate, puis upgrade vers websocket.
  // L'inverse (websocket first) bloque si le WS upgrade échoue (Docker NAT, proxy).
  transports: ["polling", "websocket"],
  upgrade: true,
  autoConnect: false,
  reconnection: true,
  // Infinity et pas 5 : un kiosque vitrine tourne des heures sur un écran. Avec
  // 5 tentatives (~5s), la moindre coupure réseau ou un redémarrage du conteneur
  // laissait le socket mort définitivement — l'écran continuait d'afficher son QR
  // alors que plus aucune room n'existait derrière. AutoRoom reprend son code à
  // chaque reconnexion (createRoom + reclaim), donc il faut que la reconnexion
  // finisse toujours par arriver.
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  // withCredentials retiré : provoque des preflight CORS lents sur chaque requête polling.
  // Non nécessaire quand le serveur autorise toutes les origines.
});

// Listeners de debug (laisser pour diagnostic en développement)
socket.on("connect", () => console.log("Connected to WebSocket server"));
socket.on("connect_error", (err) => console.error("Connection error:", err));
socket.on("disconnect", (reason) => console.log("Disconnected:", reason));
